import { render, staticRenderFns } from "./location-read-emails-detail.vue?vue&type=template&id=90024e0a&scoped=true"
import script from "./location-read-emails-detail.vue?vue&type=script&lang=js"
export * from "./location-read-emails-detail.vue?vue&type=script&lang=js"
import style0 from "./location-read-emails-detail.vue?vue&type=style&index=0&id=90024e0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90024e0a",
  null
  
)

export default component.exports